import React, { useState } from 'react';
import { Box, Paper, Grid, Stack, Button, Typography } from '@mui/material';
import { Add, VpnKey } from '@mui/icons-material';
import '../../App.css';
import Popup from '../Popup';
import ApiKeysTable from '../table-data/ApiKeysTable';
import GenerateApiKeyForm from './GenerateApiKeyForm';

function ViewApiKeys() {
  const [openPopup, setOpenPopup] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const handleAddClick = () => {
    setOpenPopup(true);
  };

  const handleGenerated = () => {
    setReloadKey((prev) => prev + 1);
  };

  const handlePopupClose = (open) => {
    setOpenPopup(open);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        padding: '30px',
        fontWeight: '500px',
      }}
    >
      <Paper elevation={0} sx={{ width: '980px' }}>
        <Grid className="form-title" style={{ marginBottom: '-60px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              API Keys
            </Typography>
          </Grid>
          <Grid item>
            <VpnKey sx={{ width: 40, height: 40, marginLeft: '-20px', color: '#344D67' }} />
          </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '30px' }} style={{ marginLeft: '51px' }}>
            <Typography variant="body2" sx={{ color: '#555', maxWidth: '820px' }}>
              Generate a key for machine-to-machine access (e.g. Finance Console). The full key is shown only once. Use it as
              Authorization: Bearer &lt;key&gt; — no login or OTP.
            </Typography>
            <Stack display="flex" sx={{ alignItems: 'flex-end' }}>
              <Button
                style={{ width: '160px', marginRight: '32px', marginBottom: '-10px', marginTop: '10px' }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={handleAddClick}
                startIcon={<Add sx={{ width: 24, height: 24 }} style={{ marginRight: '-8px' }} />}
                sx={{
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                }}
              >
                Generate API Key
              </Button>
            </Stack>

            <ApiKeysTable reloadKey={reloadKey} />
          </Stack>
        </form>

        <Popup
          title="Generate API Key"
          openPopup={openPopup}
          setOpenPopup={handlePopupClose}
        >
          <GenerateApiKeyForm onGenerated={handleGenerated} />
        </Popup>
      </Paper>
    </Box>
  );
}

export default ViewApiKeys;
